import { CampoFormik } from '../../../../components/CompUtils';
import { Formik } from 'formik';
import React from 'react';
import { Form, Table } from 'react-bootstrap';
import { createUseStyles } from 'react-jss';
import * as yup from 'yup';
import es from '../../../../yup-es';

yup.setLocale(es);

const useStyles = createUseStyles({
  labelCell: {
    textAlign: 'center',
    verticalAlign: 'middle !important',
    width: '20%',
  },
  dateCell: {
    width: 250,
  },
});

const DictamenForm = ({ onSubmit }) => {
  const classes = useStyles();

  const handleSubmit = (values) => {
    onSubmit && onSubmit(values);
  };
  const schema = yup.object({
    nroDictamen: yup.string().required(),
    nroDictamenJuridico: yup.string().required(),
    nroProyectoResolucion: yup.string().required(),
    nroResolucionBora: yup.string().required(),

    fdictamen: yup.date().required(),
    fdictamenJuridico: yup.date().required(),
    fproyectoResolucion: yup.date().required(),
    fresolucionBora: yup.date().required(),
  });
  const initial = {
    nroDictamen: '',
    nroProyectoResolucion: '',
    nroResolucionBora: '',
    nroDictamenJuridico: '',
    fdictamen: '',
    fproyectoResolucion: '',
    fresolucionBora: '',
    fdictamenJuridico: '',
  };

  return (
    <Formik
      onSubmit={handleSubmit}
      validationSchema={schema}
      validateOnChange={false}
      initialValues={initial}>
      {(formik) => (
        <Form noValidate id="formDictamen" onSubmit={formik.handleSubmit}>
          <Table bordered size="sm">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Número</th>
                <th>Fecha</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={classes.labelCell}>Dictamen</td>
                <td>
                  <CampoFormik name="nroDictamen" formik={formik} />
                </td>
                <td className={classes.dateCell}>
                  <CampoFormik type="date" name="fdictamen" formik={formik} />
                </td>
              </tr>
              <tr>
                <td className={classes.labelCell}>Proyecto resolución</td>
                <td>
                  <CampoFormik name="nroProyectoResolucion" formik={formik} />
                </td>
                <td className={classes.dateCell}>
                  <CampoFormik type="date" name="fproyectoResolucion" formik={formik} />
                </td>
              </tr>
              <tr>
                <td className={classes.labelCell}>Resolución firmada Bora</td>
                <td>
                  <CampoFormik name="nroResolucionBora" formik={formik} />
                </td>
                <td className={classes.dateCell}>
                  <CampoFormik type="date" name="fresolucionBora" formik={formik} />
                </td>
              </tr>
              <tr>
                <td className={classes.labelCell}>Dictamen jurídicos</td>
                <td>
                  <CampoFormik name="nroDictamenJuridico" formik={formik} />
                </td>
                <td className={classes.dateCell}>
                  <CampoFormik type="date" name="fdictamenJuridico" formik={formik} />
                </td>
              </tr>
            </tbody>
          </Table>
        </Form>
      )}
    </Formik>
  );
};

export default DictamenForm;
